import {
    GET_TERRAINS_SUCCESS,
    STORE_TERRAIN_SUCCESS,
    STORE_TERRAIN_FAILURE,
    DELETE_TERRAIN_SUCCESS,
    DELETE_TERRAIN_FAILURE,
    GET_TERRAIN_SUCCESS,
    GET_TERRAIN_FAILURE,
    POST_TERRAIN_STAFF_SUCCESS,
    POST_TERRAIN_STAFF_FAILURE,
    GET_TERRAIN_PLANNING_SUCCESS,
    GET_TERRAIN_PLANNING_FAILURE,
    GET_TERRAINS_ASSESSMENT_SUCCESS,
    GET_TERRAINS_ASSESSMENT_FAILURE,
    GET_TERRAINS_STAFF_MATCHING_SUCCESS,
    GET_TERRAINS_STAFF_MATCHING_FAILURE,
    POST_TERRAINS_AUTO_STAFF_MATCHING_SUCCESS,
    POST_TERRAINS_AUTO_STAFF_MATCHING_FAILURE,
    POST_TERRAINS_STAFF_CONFIRMATION_SUCCESS,
    POST_TERRAINS_STAFF_CONFIRMATION_FAILURE,
    POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_SUCCESS,
    POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_FAILURE,
    POST_TALENT_ASSESSMENT_ACTION_SUCCESS,
    POST_TALENT_ASSESSMENT_ACTION_FAILURE,
    POST_TERRAIN_STATS_DAILY_SUCCESS,
    POST_TERRAIN_STATS_DAILY_FAILURE,
    POST_TERRAIN_STAFF_ADD_SUCCESS,
    POST_TERRAIN_STAFF_ADD_FAILURE
} from '../action-types'

const INIT_STATE = {
    terrains: [],
    storedTerrain: null,
    deletedTerrain: null,
    selectedTerrain: null,
    terrainStaff: [],
    terrainPlanning: [],
    terrainAssessment: [],
    terrainStaffMatching: [],
    autoStaffMatchingCount: 0,
    staffConfirmationCount: 0,
    autoStaffMatchingTrackingCount: 0,
    talentAssessmentActionCount: 0,
    terrainStatsData: 0,
    terrainStaffAddCount: 0,
    error: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TERRAINS_SUCCESS:
            return {
                ...state,
                terrains: action.data
            }
        case STORE_TERRAIN_SUCCESS:
            console.log(action)
            return {
                ...state,
                storedTerrain: action.data,
                error: null
            }
        case STORE_TERRAIN_FAILURE:
            return {
                ...state,
                error: action.error,
                storedTerrain: null
            }
        case DELETE_TERRAIN_SUCCESS:
            return {
                ...state,
                terrains: action.data
            }
        case DELETE_TERRAIN_FAILURE:
            return {
                ...state,
                error: action.error,
                deletedTerrain: null
            }
        case GET_TERRAIN_SUCCESS:
            return {
                ...state,
                selectedTerrain: action.data,
                error: null
            }
        case GET_TERRAIN_FAILURE:
            return {
                ...state,
                error: action.error,
                selectedTerrain: null
            }
        case POST_TERRAIN_STAFF_SUCCESS:
            return {
                ...state,
                terrainStaff: action.data,
                error: null
            }
        case POST_TERRAIN_STAFF_FAILURE:
            return {
                ...state,
                error: action.error,
                terrainStaff: null
            }
        case GET_TERRAIN_PLANNING_SUCCESS:
            return {
                ...state,
                terrainPlanning: action.data,
                error: null
            }
        case GET_TERRAIN_PLANNING_FAILURE:
            return {
                ...state,
                error: action.error,
                terrainPlanning: null
            }
        case GET_TERRAINS_ASSESSMENT_SUCCESS:
            return {
                ...state,
                terrainAssessment: action.data,
                error: null
            }
        case GET_TERRAINS_ASSESSMENT_FAILURE:
            return {
                ...state,
                error: action.error,
                terrainAssessment: null
            }
        case GET_TERRAINS_STAFF_MATCHING_SUCCESS:
            return {
                ...state,
                terrainStaffMatching: action.data,
                error: null
            }
        case GET_TERRAINS_STAFF_MATCHING_FAILURE:
            return {
                ...state,
                error: action.error,
                terrainStaffMatching: null
            }
        case POST_TERRAINS_AUTO_STAFF_MATCHING_SUCCESS:
            return {
                ...state,
                autoStaffMatchingCount: state.autoStaffMatchingCount + 1,
                error: null
            }
        case POST_TERRAINS_AUTO_STAFF_MATCHING_FAILURE:
            return {
                ...state,
                error: action.error
            }
        case POST_TERRAINS_STAFF_CONFIRMATION_SUCCESS:
            return {
                ...state,
                staffConfirmationCount: state.staffConfirmationCount + 1,
                error: null
            }
        case POST_TERRAINS_STAFF_CONFIRMATION_FAILURE:
            return {
                ...state,
                error: action.error
            }
        case POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_SUCCESS:
            return {
                ...state,
                autoStaffMatchingTrackingCount: action.data,
                error: null
            }
        case POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_FAILURE:
            return {
                ...state,
                error: action.error
            }
        case POST_TALENT_ASSESSMENT_ACTION_SUCCESS:
            return {
                ...state,
                talentAssessmentActionCount: state.talentAssessmentActionCount + 1,
                error: null
            }
        case POST_TALENT_ASSESSMENT_ACTION_FAILURE:
            return {
                ...state,
                error: action.error
            }
        case POST_TERRAIN_STATS_DAILY_SUCCESS:
            return {
                ...state,
                terrainStatsData: action.data,
                error: null
            }
        case POST_TERRAIN_STATS_DAILY_FAILURE:
            return {
                ...state,
                error: action.error
            }
        case POST_TERRAIN_STAFF_ADD_SUCCESS:
            return {
                ...state,
                terrainStaffAddCount: state.terrainStaffAddCount + 1,
                error: null
            }
        case POST_TERRAIN_STAFF_ADD_FAILURE:
            return {
                ...state,
                error: action.error
            }
        default:
            return state
    }
}
